import { createFileRoute } from '@tanstack/react-router';
import PluginAuthPage from '@/pages/auth/PluginAuthPage';

/**
 * Plugin authentication route (Spec 003, AC1)
 *
 * This route handles the OAuth flow for C++ plugins.
 * Plugins open this URL in the browser with state and redirect parameters.
 */
export const Route = createFileRoute('/auth/plugin')({
  component: PluginAuthPage,
});
